import React from 'react';
import { Helmet } from 'react-helmet-async';
import HorizontalMenu from '../components/common/horizontalMenu';

const OurStory: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Our Story | Meet the Founders of MrJoe.Pro</title>
        <meta name="description" content="Learn about Emmanuel Wang and Jia Wang, the founders of MrJoe.Pro. From construction sites to Stanford research, discover how we built software to help contractors succeed." />
        <meta name="keywords" content="MrJoe.Pro founders, Emmanuel Wang, Jia Wang, contractor software story, Buildmetric team, who created MrJoe.Pro" />
        <link rel="canonical" href="https://mrjoe.pro/pub/our_story" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mrjoe.pro/pub/our_story" />
        <meta property="og:title" content="Our Story | MrJoe.Pro" />
        <meta property="og:description" content="From construction sites to software development - learn how MrJoe.Pro was built to help small contractors grow their businesses." />
        
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Our Story | MrJoe.Pro" />
        <meta name="twitter:description" content="From construction sites to software development - learn how MrJoe.Pro was built to help small contractors grow their businesses." />
      </Helmet>

      <HorizontalMenu />
      <div className="container mx-auto max-w-4xl px-4 py-6">
        <h2 className="text-2xl font-semibold text-center mb-8">Our Story</h2>
        <div className="space-y-4 text-base leading-relaxed text-foreground">
          <p>
            <strong>Emmanuel Wang</strong> is currently pursuing his studies in computer science and
            participating in a small research group at Stanford University. He holds a BS in Digital Art and
            Science from the University of Florida. While studying in college, he worked part-time at
            construction sites, where he noticed that many small contractors desperately needed a convenient,
            efficient, and low-cost digital tool to help take their businesses to the next level. This
            realization led to the creation of <strong>MrJoe.pro</strong>.
          </p>
          <p>
            <strong>Jia Wang</strong> is a veteran in the IT industry with over 30 years of experience. He has
            worked with and provided consulting services to more than 30 U.S. companies. He holds a Ph.D. from
            the Swiss Federal Institute of Technology and an MBA from Florida State University.
          </p>
          <p>Together, they are the founders and driving forces behind the implementation of MrJoe.pro.</p>
        </div>
      </div>
    </>
  );
};

export default OurStory;